import weixinApi from "@/utils/weixinApi"

export default {
  methods: {
    weixinShare(params) {
      weixinApi.share(params)
    },
    weixinGetLocation(params) {
      weixinApi.getLocation(params)
    },
    weixinScanQRCode(params) {
      weixinApi.scanQRCode(params)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/weixinHelper.js